import axios from 'axios'
import _get from 'lodash/get'

export const INVESTMENT_SCHEMES_GET = 'INVESTMENT_SCHEMES_GET'
export const INVESTMENT_SCHEMES_UPDATE = 'INVESTMENT_SCHEMES_UPDATE'
export const INVESTMENT_SCHEMES_SAVE = 'INVESTMENT_SCHEMES_SAVE'
export const INVESTMENT_SCHEMES_SAVING = 'INVESTMENT_SCHEMES_SAVING'
export const INVESTMENT_SCHEMES_SAVE_SUCCESS = 'INVESTMENT_SCHEMES_SAVE_SUCCESS'
export const INVESTMENT_SCHEMES_SAVE_ERROR = 'INVESTMENT_SCHEMES_SAVE_ERROR'

export const getInvestmentSchemes = (selfAssessmentId) => (dispatch) => {
    axios
        .get(`/investmentschemes/${selfAssessmentId}`)
        .then((response) => {
            const investmentSchemes = { ...response.data, fetchSuccessful: true }

            dispatch(updateInvestmentSchemes(investmentSchemes))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) {
                dispatch(updateInvestmentSchemes({ fetchSuccessful: true }))
            }
        })
}

export const updateInvestmentSchemes = (investmentSchemes) => ({
    type: INVESTMENT_SCHEMES_UPDATE,
    investmentSchemes,
})

export const saveInvestmentSchemes = () => (dispatch, getState) => {
    const { assessment, investmentSchemes } = getState()

    dispatch(investmentSchemesSaving, investmentSchemes)

    axios
        .put(`/investmentschemes/${assessment.id}`, { ...investmentSchemes, selfAssessmentId: assessment.id })
        .then((response) => {
            const data = { ...response.data, isAllowanceUpdate: investmentSchemes.isAllowanceUpdate }

            dispatch(investmentSchemesSaveSuccess(data))
        })
        .catch((error) => {
            dispatch(investmentSchemesSaveError(investmentSchemes, _get(error, ['response', 'data'])))
        })
}

export const updateAndSaveInvestmentSchemes = (investmentSchemes) => (dispatch) => {
    dispatch(updateInvestmentSchemes(investmentSchemes))
    dispatch(saveInvestmentSchemes())
}

export const investmentSchemesSaving = (investmentSchemes) => ({
    type: INVESTMENT_SCHEMES_SAVING,
    investmentSchemes,
})

export const investmentSchemesSaveSuccess = (investmentSchemes) => ({
    type: INVESTMENT_SCHEMES_SAVE_SUCCESS,
    investmentSchemes,
})

export const investmentSchemesSaveError = (investmentSchemes, errorResponse) => ({
    type: INVESTMENT_SCHEMES_SAVE_ERROR,
    investmentSchemes,
    errorResponse,
})
